import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from '@upmc/ims.component-library';
import * as actions from '../../../../store/apps/actions';
import classes from './componentContainer.module.scss';
import { Subtitle1 } from '@material/react-typography';
import { MDCListDivider } from '../../MDC/List/List';
import Icon from '../../../UI/MDC/Icon/Icon';

const ComponentContainer = props => {
	const STYLE_BUTTON_SUBMIT = 'mdc-button-submit';
	const STYLES_CONTAINER_LIST = 'container-list';

	const { componentId, appId } = props;
	const dispatch = useDispatch();
	const reduxState = useSelector(state => state.apps);

	const onClickHandler = payload => {
		dispatch(
			actions.removeContainer({
				appId: appId,
				componentKey: componentId,
			})
		);
	};

	useEffect(() => {
		dispatch(
			actions.updateContainerValue({
				appId: appId,
				componentKey: componentId,
			})
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	let placeholder = null;
	if (props.extras && props.extras.epcs && props.extras.epcs[0].placeholder) {
		let tmp = props.extras.epcs[0].placeholder;
		tmp = tmp.replace(
			'$1',
			reduxState.allForms[0].model.members[
				props.extras.epcs[1].keys[0].comp
			].value
		);
		tmp = tmp.replace(
			'$2',
			reduxState.allForms[0].model.members[
				props.extras.epcs[1].keys[1].comp
			].value
		);
		tmp = tmp.replace(
			'$3',
			reduxState.allForms[0].model.members[
				props.extras.epcs[1].keys[2].comp
			].value
		);
		const piece = tmp;
		placeholder = <div>{piece}</div>;
	}
	const removeButton = props.indent ? (
		<IconButton
			onClick={payload => onClickHandler(payload)}
			className={classes[STYLE_BUTTON_SUBMIT]}
		>
			<Icon icon='clear' />
		</IconButton>
	) : null;

	const styles = props.containerList ? STYLES_CONTAINER_LIST : null;
	return (
		<section className={styles}>
			<MDCListDivider tag='div' className={classes['divider_space']} />
			<div className={classes['container_banner']}>
				<Subtitle1>
					{props.label}: {placeholder}
				</Subtitle1>
				{removeButton}
			</div>
		</section>
	);
};

export default ComponentContainer;
